"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceCodeUpdateRequest_1 = require("../model/PriceCodeUpdateRequest");

var PriceCodeUpdateRequestConverter_1 = require("./PriceCodeUpdateRequestConverter");
/**
 * @author Radek Beran
 */


var PriceCodeUpdateRequestConverterImpl =
/*#__PURE__*/
function (_PriceCodeUpdateReque) {
  _inherits(PriceCodeUpdateRequestConverterImpl, _PriceCodeUpdateReque);

  function PriceCodeUpdateRequestConverterImpl() {
    _classCallCheck(this, PriceCodeUpdateRequestConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceCodeUpdateRequestConverterImpl).apply(this, arguments));
  }

  _createClass(PriceCodeUpdateRequestConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceCodeUpdateRequest_1.PriceCodeUpdateRequest(PriceCodeUpdateRequest_1.PriceCodeUpdateRequest.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), PriceCodeUpdateRequest_1.PriceCodeUpdateRequest.schema.priceCode.valueOf(conversions.toClassReferenceId(source.priceCode)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        priceCode: conversions.toDocumentReferenceId(source.priceCode)
      });
      return result;
    }
  }]);

  return PriceCodeUpdateRequestConverterImpl;
}(PriceCodeUpdateRequestConverter_1.PriceCodeUpdateRequestConverter);

exports.PriceCodeUpdateRequestConverterImpl = PriceCodeUpdateRequestConverterImpl;